import { Link } from "react-router-dom";
import { IMAGES } from "@/data/menu";

export default function Story() {
  return (
    <div data-testid="story-page">
      {/* Page hero band */}
      <section className="py-14 md:py-20" style={{ background: "var(--goat-green)" }}>
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <span className="badge-sticker inline-block px-5 py-2 text-sm font-semibold uppercase tracking-widest mb-5" style={{ background: "var(--goat-orange)", color: "var(--goat-white)", borderColor: "var(--goat-cream)", boxShadow: "3px 3px 0px var(--goat-cream)" }} data-testid="story-badge">
            Our Story
          </span>
          <h1 className="text-5xl md:text-6xl uppercase tracking-tighter" style={{ color: "var(--goat-cream)" }} data-testid="story-heading">
            G.O.A.T Sliders
          </h1>
        </div>
      </section>

      {/* Full story */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20" data-testid="story-content">
        <div className="grid md:grid-cols-2 gap-10 items-start">
          <div>
            <p className="text-lg md:text-xl" style={{ color: "var(--goat-green)" }} data-testid="story-text-1">
              Every food brand has a beginning. G.O.A.T Sliders started with a long-standing dream of creating something of our own in the world of food. The idea was never just to open another food outlet or add one more name to the list of burger and sandwich brands. The goal was to build something different, with a menu that reflected a genuine love for experimenting with flavours.
            </p>
            <p className="mt-4 text-lg md:text-xl" style={{ color: "var(--goat-green)" }} data-testid="story-text-2">
              That thought led to one question: why stick to the usual when food offers so many possibilities?
            </p>
            <p className="mt-4 text-lg md:text-xl" style={{ color: "var(--goat-green)" }} data-testid="story-text-3">
              The answer came in the form of sliders. Small, versatile and full of potential, sliders offered the perfect canvas to bring together familiar ingredients, unexpected combinations and flavours inspired by different cuisines. What began as an idea gradually took shape into a menu built around one simple philosophy: small bites should never mean small flavours.
            </p>
          </div>
          <div className="sticker-card sticker-card-orange overflow-hidden p-0 min-h-72 md:sticky md:top-32">
            <img src={IMAGES.veg} alt="Fresh GOAT sliders" className="w-full h-80 md:h-full object-cover" data-testid="story-image" />
          </div>
        </div>

        <div className="mt-10 max-w-3xl space-y-4">
          <p className="text-lg md:text-xl" style={{ color: "var(--goat-green)" }} data-testid="story-text-4">
            At G.O.A.T Sliders, every recipe is created with attention to the little things that make food enjoyable. Soft, toasted pav, flavourful fillings, homemade sauces and generous amounts of cheese form the heart of our sliders. From the first bite to that satisfying cheese pull, every element has a role to play.
          </p>
          <p className="text-lg md:text-xl" style={{ color: "var(--goat-green)" }} data-testid="story-text-5">
            The menu brings together Indian comfort food and global inspirations. There is the familiar goodness of Cheesy Pav Bhaji and Paneer Tikka Sliders, the Italian-inspired flavours of Pizza Sliders and the bold taste of Korean Kimchi Sliders. For those who enjoy meatier flavours, options such as Butter Chicken, Chicken Keema and Mutton Keema Sliders add another dimension to the experience.
          </p>
          <p className="text-lg md:text-xl" style={{ color: "var(--goat-green)" }} data-testid="story-text-6">
            The experience doesn't end with sliders. Crispy fries, baked cheesy nachos and indulgent brownies make it easy to turn a quick snack into a complete food feast.
          </p>
        </div>

        <div className="mt-10 sticker-card sticker-card-orange p-8 md:p-10" data-testid="story-goat-card">
          <p className="text-lg md:text-xl" style={{ color: "var(--goat-green)" }} data-testid="story-text-7">
            The name G.O.A.T stands for <span className="font-display">Greatest of All Times</span>. It's a playful expression of the ambition behind the brand: to create food that people remember, recommend and crave again.
          </p>
          <p className="mt-4 font-display text-xl md:text-2xl uppercase" style={{ color: "var(--goat-orange)" }} data-testid="story-text-8">
            Born from a simple desire to do something different, G.O.A.T Sliders is all about creative combinations, homemade flavours and plenty of cheese.
          </p>
        </div>

        <div className="mt-14 text-center">
          <Link
            to="/menu"
            className="sticker-btn inline-block px-8 py-4 font-display uppercase text-base"
            style={{ background: "var(--goat-orange)", color: "var(--goat-white)" }}
            data-testid="story-menu-btn"
          >
            See The Menu
          </Link>
        </div>
      </section>
    </div>
  );
}
